import localStore from '@/global/store/local-store';
import axios, { AxiosResponse } from 'axios';

export interface StdResponse<T = any> extends AxiosResponse<T> {
    message: string
}

// 状态码定义
// const codeMessage = {
//     200: 'ok',
//     400: '请求数据错误',
//     401: '用户没有权限',
//     404: '请求的资源不存在',
//     500: '服务器异常',
//     503: '服务器过载或维护',
//     504: '网关超时',
// }

// const monixBaseUrl = "http://127.0.0.1:4523/m1/4830371-4485388-default"
const monixBaseUrl = "/api"

const request = axios.create({
    baseURL: monixBaseUrl,
    timeout: 60000,
});

request.interceptors.request.use(
    config => {
        let token = localStore.token || '';
        config.headers.token = token;
        return config;
    },
    err => {
        console.log(err);
    }
)
request.interceptors.response.use(
    response => {
        if (response.headers['content-type']?.indexOf('application/json') >= 0) {
            return response.data;
        }
        return response;
    },
    (err) => {
        const error = err.response;
        if (!error) {
            return Promise.reject("发生其他异常");
        }
        if (error.status === 401) {
            // 未授权登录
            localStore.clear();
            window.location.href = "/login";
        }
        return Promise.reject(error);
    }
)

export { request };

